import { useMemo, useState } from 'react';
import { Dialog, useMediaQuery, IconButton, Box } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import Main from './Main';
import Update from './Update';
import ACSnackbar from '../../../components/ACSnackbar';

const useStyles = ({ isXS }) => ({
  imageWrapper: {
    display: 'flex',
    width: '100%',
    justifyContent: 'center',
    marginBottom: isXS ? '0px' : '8px',
  },
  dialogContainer: {
    padding: isXS ? '0px' : '10px',
  },
  dialog: {
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    justifyContent: 'center',
    width: isXS ? '' : '600px',
    height: 'auto',
    alignItems: 'center',
    background: '#FFFFFF',
    borderRadius: isXS ? '0px' : '15px',
    paddingTop: isXS ? '24px' : '24px',
    paddingBottom: isXS ? '0px' : '30px',
  },
});

export default function PrioritiesModal({ open, setIsOpen, survey }) {
  const [activeStep, setActiveStep] = useState(0);
  const [updateType, setUpdateType] = useState('');
  const [blockClosePopup, setBlockClosePopup] = useState(false);
  const [isSnackbarVisible, setIsSnackbarVisible] = useState(false);

  function handleClose() {
    if (blockClosePopup) {
      return;
    }
    setIsOpen(false);
    setActiveStep(0);
  }

  const steps = useMemo(() => {
    return [
      <Main
        setActiveStep={setActiveStep}
        survey={survey}
        setUpdateType={setUpdateType}
      />,
      <Update
        updateType={updateType}
        setBlockClosePopup={setBlockClosePopup}
        handleClose={handleClose}
        setIsSnackbarVisible={setIsSnackbarVisible}
      />,
    ];
  }, [survey, updateType]);

  const isXS = useMediaQuery((theme) => theme.breakpoints.down('xs'));
  const classes = useStyles({ isXS });

  return (
    <Dialog
      open={open}
      sx={classes.dialogContainer}
      fullScreen={isXS}
      PaperProps={{ style: { borderRadius: { xxs: 0, sm: 15 } } }}
      onClose={handleClose}
    >
      <ACSnackbar
        onClose={() => setIsSnackbarVisible(false)}
        open={isSnackbarVisible}
        severity="error"
        text={
          updateType === 'goal'
            ? 'Something went wrong updating the current challenge.'
            : 'Something went wrong creating the survey.'
        }
      />
      <div style={classes.dialog}>
        {isXS && (
          <IconButton
            size="small"
            onClick={handleClose}
            sx={{ position: 'absolute', top: 0, right: 0 }}
          >
            <CloseIcon />
          </IconButton>
        )}

        <Box sx={{ width: 550, overflow: 'hidden', position: 'relative' }}>
          <Box
            sx={{
              display: 'flex',
              width: `${steps.length * 100}%`,
              transform: `translateX(-${activeStep * (100 / steps.length)}%)`,
              transition: 'transform 0.5s cubic-bezier(0.4,0,0.2,1)',
            }}
          >
            {steps.map((step, idx) => (
              <Box
                key={idx}
                sx={{ width: `${100 / steps.length}%`, flexShrink: 0 }}
              >
                {step}
              </Box>
            ))}
          </Box>
        </Box>
      </div>
    </Dialog>
  );
}
